export function passwordEncode(email: string, password: string) {
  return btoa(`${email}:${password}`);
}



// WEBPACK FOOTER //
// ./src/util/auth.util.tsx